import styled, { css } from 'styled-components/macro';
import { graySecondaryDark } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const TitledContent = styled.div`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};

  ${({ flex }) =>
    flex
      ? css`
          justify-content: center;
          flex-direction: column;
        `
      : css`
          ${({ fullWidth }) =>
            fullWidth &&
            css`
              display: grid;
              justify-content: start;
              grid-column: span 2;
              ${media.desktop`
          grid-column: span 3;
      `}
            `}
          ${({ twoColumns }) =>
            twoColumns &&
            css`
              ${media.desktop`
        grid-column: span 2;
      `}
            `}
        `};
`;

export const Label = styled.label`
  color: ${graySecondaryDark};
  ${fontSize(12)};
  margin-bottom: 6px;
`;

export const Content = styled.p`
  font-weight: bold;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? '15px' : '0')};
  word-break: ${({ wordBreakAll }) => wordBreakAll && 'break-all'};
  ${fontSize(14)};
  ${media.desktop`
    ${fontSize(16)};
  `}
`;
